/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx, keyframes } from '@emotion/react';
var LoadingSkeleton = function LoadingSkeleton(_ref) {
  var testId = _ref.testId,
    width = _ref.width,
    height = _ref.height;
  var animationNameStyles = keyframes({
    '0%': {
      backgroundPosition: '50% 0'
    },
    '100%': {
      backgroundPosition: '-50% 0'
    }
  });
  var styles = css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: "".concat(width, "rem"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: "".concat(height, "rem"),
    borderRadius: '2px',
    userSelect: 'none',
    background: "var(--ds-skeleton-subtle, #f6f7f8)",
    backgroundImage: "linear-gradient( to right, transparent 0%, ".concat("var(--ds-skeleton, #edeef1)", " 20%, transparent 40%, transparent 100% )"),
    backgroundRepeat: 'no-repeat',
    backgroundSize: '280% 100%',
    display: 'inline-block',
    animationDuration: '1s',
    animationFillMode: 'forwards',
    animationIterationCount: 'infinite',
    animationName: animationNameStyles,
    animationTimingFunction: 'linear'
  });

  // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- needs dynamic css
  return jsx("span", {
    css: styles,
    "data-testid": testId
  });
};
export default LoadingSkeleton;